import React from "react";

import LoadingComponent from "components/LoadingComponent";

import { ILoadSpinner } from "./interface";
import { LoadingContainer } from "./styled";

export const LoadSpinner: React.FC<ILoadSpinner> = ({ loading, zindex }) => {
  return (
    <>
      {loading ? (
        <LoadingContainer zindex={zindex}>
          <LoadingComponent loading={loading} />
        </LoadingContainer>
      ) : null}
    </>
  );
};
